// extracted by mini-css-extract-plugin
export default {"container":"D7h_Im","containerLabel":"lyrMya"};